/**

@module

## Anatomy

```jsx
import {
  AutocompleteEmpty,
  AutocompleteItem,
  AutocompletePopup,
  AutocompletePositioner,
  AutocompleteRoot,
} from 'prosekit/react/autocomplete'

<AutocompleteRoot>
  <AutocompletePositioner>
    <AutocompletePopup>
      <AutocompleteItem>...</AutocompleteItem>
      <AutocompleteEmpty>...</AutocompleteEmpty>
    </AutocompletePopup>
  </AutocompletePositioner>
</AutocompleteRoot>
```
*/

'use client'

export * from './index.gen.ts'
